module.exports = __webpack_public_path__ + "static/media/slack.b2eb5635.png";